



























































































import { Component, Emit, Ref, Vue } from "vue-property-decorator";
import { AxiosResponse, AxiosError } from "axios";
import AppTextField from "#/components/AppTextField.vue";
import { VForm } from "@/types";

@Component({
  components: {
    AppTextField,
  },
})
export default class ChangePassword extends Vue {
  @Ref("password_form") private readonly form!: VForm;

  private oldPassword = "";
  private newPassword = "";
  private confirmPassword = "";
  private showNew = false;
  private showConfirm = false;
  private loading = false;
  private errorMessage = "";

  private async submit() {
    if (!this.form.validate()) {
      return;
    }

    this.loading = true;
    this.errorMessage = "";

    window.axios
      .post(
        window.base_url + "/api/admin/change-password",
        {
          old_password: this.oldPassword,
          new_password: this.newPassword,
        },
        {
          headers: {
            Authorization: "Bearer " + window.token,
          },
        }
      )
      .then(async (res: AxiosResponse) => {
        this.loading = false;
        if (res.data.code > 0) {
          this.errorMessage = res.data.message;
        } else {
          await this.$openAlert("パスワードを変更しました。");
          this.changed();
        }
      })
      .catch(async (error: AxiosError) => {
        this.loading = false;
        if (error.response && error.response.status == 401) {
          await this.$openAlert("セッションがタイムアウトになりました。");
        } else {
          this.errorMessage = "パスワードの変更に失敗しました。";
        }
      });
  }

  @Emit("changed")
  private changed() {
    return;
  }
}
